class CouponCopy extends HTMLElement {
    constructor() {
        super();
        this._buttonSelector = '.copy-button';
        this._copyButton = null;
        this._originalButtonText = '';
    }

    connectedCallback() {
        this._copyButton = this.querySelector(this._buttonSelector);

        if (!this._copyButton) {
            console.error("Cannot find .copy-button element");
            return;
        }

        this._originalButtonText = this._copyButton.textContent;

        this._copyButton.addEventListener('click', () => this.copy());
    }

    async copy() {
        const couponCode = this.getAttribute('data-code');
        if (couponCode) {
            try {
                await navigator.clipboard.writeText(couponCode);
                this.buttonValue();
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        } else {
            console.error('No data-code attribute found on element');
        }
    }

    buttonValue() {
        if (!this._copyButton) return;

        this._copyButton.textContent = 'Copied';
        setTimeout(() => {
            this._copyButton.textContent = this._originalButtonText;
        }, 2000);
    }
}

customElements.define('coupon-copy', CouponCopy);

let eventFlashSaleSwiperSwitchsInstances = new Map();

class EventFlashSaleSwiperSwitchs extends HTMLElement {
    constructor() {
        super();
        this._swiperContainer = this.querySelector('.event-flash-sale-swiper-switchs');
        this._pageWidth = window.innerWidth;
        this._switchsWidth = this._swiperContainer.clientWidth;
        this._switchItems = this.querySelectorAll('.event-flash-sale-swiper-switchs-item');
        this._resizeHandler = this.resizeFunction.bind(this);
        this._updateExecuted = false;
    }

    connectedCallback() {
        requestAnimationFrame(() => {
            this.initializeSwiper();
            this.resizeFunction();
            window.addEventListener('resize', this._resizeHandler);
        });
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this._resizeHandler);
    }

    initializeSwiper() {
        const sectionId = this.dataset.sectionId;
        
        if (!sectionId) {
            console.error('No data-section-id attribute found for event-flash-sale-swiper-switchs');
            return;
        }

        eventFlashSaleSwiperSwitchsInstances.set(sectionId, new Swiper(this._swiperContainer, {
            slidesPerView: 'auto',
            slideToClickedSlide: true,
            on: {
                click: () => {
                    if (!this._updateExecuted) {
                        eventFlashSaleSwiperSwitchsInstances.get(sectionId).update();
                        this._updateExecuted = true;
                    }
                    const clickedIndex = eventFlashSaleSwiperSwitchsInstances.get(sectionId).clickedIndex;
                    if (clickedIndex !== undefined && clickedIndex !== null) {
                        eventFlashSaleSwiperSwitchsInstances.get(sectionId).slideToLoop(clickedIndex);
                        // Update the corresponding product swiper
                        const productSwiper = document.querySelector(`event-flash-sale-products-swiper[data-section-id="${sectionId}"] .event-flash-sale-products-box`);
                        if (productSwiper && productSwiper.swiper) {
                            productSwiper.swiper.slideToLoop(clickedIndex);
                        }
                    }
                },
            }
        }));
    }

    resizeFunction() {
        if (this._pageWidth <= 749) {
            if (this._switchsWidth > this._pageWidth) {
                this._swiperContainer.classList.add('event-flash-sale-swiper-switchs-auto');
            } else {
                this._swiperContainer.classList.remove('event-flash-sale-swiper-switchs-auto');
            }
        }
    }
}

customElements.define('event-flash-sale-swiper-switchs', EventFlashSaleSwiperSwitchs);

class EventFlashSaleSwiper extends HTMLElement {
    constructor() {
        super();
        this._swiperContainer = this.querySelector('.event-flash-sale-products-box');
    }

    connectedCallback() {
        requestAnimationFrame(() => {
            this.initializeSwiper();
        });
    }

    initializeSwiper() {
        const sectionId = this.dataset.sectionId;

        if (!sectionId) {
            console.error('No data-section-id attribute found for event-flash-sale-products-swiper');
            return;
        }

        const switchSwiper = eventFlashSaleSwiperSwitchsInstances.get(sectionId);

        if (switchSwiper) {
            this._swiper = new Swiper(this._swiperContainer, {
                slidesPerView: 1,
                thumbs: {
                    swiper: switchSwiper,
                }
            });
        } else {
            console.error(`No corresponding event-flash-sale-swiper-switchs found for section ID: ${sectionId}`);
        }
    }
}

customElements.define('event-flash-sale-products-swiper', EventFlashSaleSwiper);



/* Header Dropdown Menu */
class HeaderMenu extends HTMLElement {
    constructor() {
        super();
        this.linkList = this.querySelector('.header_dropdown_link_list');
        this.linkItems = this.querySelectorAll('.header_dropdown_link_item');
        this.productBoxes = this.querySelectorAll('.header_dropdown__product-box');
        this.hasChildLinks = document.querySelectorAll('.has-childlink');

        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.showMask = this.toggleMask.bind(this, true);
        this.hideMask = this.toggleMask.bind(this, false);
    }

    connectedCallback() {
        this.linkItems.forEach(item => {
            item.addEventListener('mouseenter', this.handleMouseEnter);
        });

        this.hasChildLinks.forEach(item => {
            item.addEventListener('mouseenter', this.showMask);
            item.addEventListener('mouseleave', this.hideMask);
        });

    }

    disconnectedCallback() {
        this.linkItems.forEach(item => {
            item.removeEventListener('mouseenter', this.handleMouseEnter);
        });

        this.hasChildLinks.forEach(item => {
            item.removeEventListener('mouseenter', this.showMask);
            item.removeEventListener('mouseleave', this.hideMask);
        });
    }

    handleMouseEnter(event) {
        const target = event.currentTarget;

        if (target.classList.contains('active')) {
            return;
        }

        this.linkItems.forEach(item => {
            item.classList.remove('active');
        });

        target.classList.add('active');

        const index = target.getAttribute('data-index');

        this.productBoxes.forEach(box => {
            box.classList.remove('active');
        });

        const activeBox = Array.from(this.productBoxes).find(box => box.getAttribute('data-index') === index);
        if (activeBox) {
            activeBox.classList.add('active');
        }
    }

    toggleMask(show) {
        const sectionHeader = document.querySelector('.section-header.shopify-section-group-header-group');
        if (sectionHeader) {
            if (show) {
                sectionHeader.classList.add('show-mask');
            } else {
                sectionHeader.classList.remove('show-mask');
            }
        }
    }
}

customElements.define('header-menu', HeaderMenu);

/* Header Menu Drawer */
class HeaderMenuDrawer extends HTMLElement {
    constructor() {
        super();
        this.showSubmenu = this.showSubmenu.bind(this);
        this.hideSubmenu = this.hideSubmenu.bind(this);
        this.showChildItem = this.showChildItem.bind(this);
    }

    connectedCallback() {
        this.menuDrawerFirst = this.querySelectorAll('.menu-drawer-first');
        this.menuDrawerBack = this.querySelectorAll('.menu-drawer__back');
        this.menuDrawerSecondBox = this.querySelectorAll('.menu-drawer-second-box');

        this.menuDrawerFirst.forEach(item => {
            item.addEventListener('click', this.showSubmenu);
        });

        this.menuDrawerBack.forEach(item => {
            item.addEventListener('click', this.hideSubmenu);
        });

        this.menuDrawerSecondBox.forEach(item => {
            item.addEventListener('click', this.showChildItem);
        });
    }

    disconnectedCallback() {
        this.menuDrawerFirst.forEach(item => {
            item.removeEventListener('click', this.showSubmenu);
        });

        this.menuDrawerBack.forEach(item => {
            item.removeEventListener('click', this.hideSubmenu);
        });

        this.menuDrawerSecondBox.forEach(item => {
            item.removeEventListener('click', this.showChildItem);
        });
    }

    showSubmenu(event) {
        event.stopPropagation();
        const target = event.currentTarget;
        const submenu = target.querySelector('.menu-drawer__submenu');
        if (submenu) {
            submenu.classList.add('active');
        }
    }

    hideSubmenu(event) {
        event.stopPropagation();
        const target = event.currentTarget;
        const submenu = target.closest('.menu-drawer__submenu');
        if (submenu) {
            submenu.classList.remove('active');
        }
    }

    showChildItem(event) {
        event.stopPropagation();
        const target = event.currentTarget;
        const parentBox = target.closest('.menu-drawer-second');
        const productMenu = target.nextElementSibling;

        if (productMenu) {
            const isVisible = $(productMenu).is(':visible');
            const parentBoxHasActive = parentBox.classList.contains('active');
            if (isVisible && parentBoxHasActive) {
                parentBox.classList.remove('active');
                $(productMenu).slideUp();
            } else {
                parentBox.classList.add('active');
                $(productMenu).slideDown();
            }
        }
    }
}

customElements.define('header-menu-drawer', HeaderMenuDrawer);

// quick jump bar  quick-jump-bar.liquid
class QuickJumpBar extends HTMLElement {
    constructor() {
        super();
        this.items = [];
        this.sticky = false;
    }

    connectedCallback() {
        this.items = this.querySelectorAll('.quick-jump-bar-item');
        this.sticky = this.dataset.sticky === "true";

        this.enableSticky();
        this.attachEvents();
    }

    enableSticky() {
        if (this.sticky) {
            document.body.classList.add('header_no_sticky');
        }
    }

    inTheArea() {
        const viewportCenter = window.innerHeight / 2 + window.scrollY;

        this.items.forEach(item => {
            const targetId = item.getAttribute('data-target-id');
            const targetElement = document.getElementById(targetId);
          if(targetElement){
            
            const rect = targetElement.getBoundingClientRect();
            const top = rect.top + window.scrollY;
            const bottom = rect.bottom + window.scrollY;

            if (viewportCenter >= top && viewportCenter <= bottom) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
          }
        });
    }

    jumpTo(event) {
        const targetId = event.currentTarget.getAttribute('data-target-id');
        const targetElement = document.getElementById(targetId);

        const offsetTop = this.sticky ? targetElement.offsetTop - this.offsetHeight : targetElement.offsetTop;

        window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
        });

        this.scrollItemToCenter(event.currentTarget);
    }

    scrollItemToCenter(item) {
        const wrapper = this.querySelector('.quick-jump-bar-wrapper');
        const wrapperRect = wrapper.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const wrapperScrollLeft = wrapper.scrollLeft;

        const offsetLeft = itemRect.left - wrapperRect.left + wrapperScrollLeft - (wrapperRect.width / 2) + (itemRect.width / 2);

        wrapper.scrollTo({
            left: offsetLeft,
            behavior: 'smooth'
        });
    }

    attachEvents() {
        this.items.forEach(item => {
            item.addEventListener('click', this.jumpTo.bind(this));
        });

        window.addEventListener('scroll', this.inTheArea.bind(this));
    }
}

customElements.define('quick-jump-bar', QuickJumpBar);
